import './styles/App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'react-datepicker/dist/react-datepicker.css'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LoginView from './views/LoginView'
import DashboardView from './views/DashboardView'

// import {useState} from 'react'

function App() {
//   const [currentView, setCurrentView] = useState(null);

  return (
<div className="App">
	<Router>
		<Routes>
			<Route path="/" element={<LoginView />} />
			<Route path="/login" element={<LoginView />} />
			<Route path="/dashboard" element={<DashboardView />} />
		</Routes>
	</Router>
</div>
  );
}

export default App;
